import { createElement, DetailedHTMLProps, HTMLAttributes, FunctionComponent } from "react"

type Props = DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>

function createTextComponent(
    tag: "h1" | "h2" | "h3" | "h4",
    classNameProp: string
): FunctionComponent<Props> {
    function Component({ className, ...props }: Props) {
        return createElement(tag, {
            ...props,
            className: [classNameProp, className].join(" "),
        })
    }
    Component.displayName = tag
    return Component
}

export const Headline1 = createTextComponent("h1", "blm-h1")
export const Headline2 = createTextComponent("h2", "blm-h2")
export const Headline3 = createTextComponent("h3", "blm-h3")
export const Headline4 = createTextComponent("h4", "blm-h4")
